import { DriverCertificationUpdatedEvent } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/driver_certification_events_pb';
import { Col, DiffViewer, IDField } from '@rematter/ui-web';

import { protoTimestampToZonedDateTimeString } from '@/audit-log/_components/_shared';

type DriverCertificationUpdatedDetailProps = {
  event: DriverCertificationUpdatedEvent;
};

export const DriverCertificationUpdatedDetail = ({
  event,
}: DriverCertificationUpdatedDetailProps) => {
  const previous = event.previousDriverCertification;
  const current = event.updatedDriverCertification;

  if (!previous || !current) {
    return (
      <Col className="@DriverCertificationUpdatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const diffs = [
    {
      field: 'type',
      label: 'Type',
      previous: previous.type,
      current: current.type,
    },
    {
      field: 'number',
      label: 'Number',
      previous: previous.number,
      current: current.number,
    },
    {
      field: 'issuingBody',
      label: 'Issuing Body',
      previous: previous.issuingBody,
      current: current.issuingBody,
    },
    {
      field: 'issuedDate',
      label: 'Issued Date',
      previous: protoTimestampToZonedDateTimeString(previous.issuedDate),
      current: protoTimestampToZonedDateTimeString(current.issuedDate),
    },
    {
      field: 'expirationDate',
      label: 'Expiration Date',
      previous: protoTimestampToZonedDateTimeString(previous.expirationDate),
      current: protoTimestampToZonedDateTimeString(current.expirationDate),
    },
  ];

  return (
    <Col className="@DriverCertificationUpdatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          Certification
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="Certification ID" value={current.id?.value} />
          <IDField label="Driver ID" value={current.driverId?.value} />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          Changes
        </span>
        <DiffViewer diffs={diffs} previousLabel="Before" currentLabel="After" />
      </Col>
    </Col>
  );
};
